module.exports = __webpack_public_path__ + "static/pic07-cadcc980e3a8db8ce1ba918db668e052.jpg";